@if (contentlet()) { @if (carouselContents?.length > 0) {
<div (touchstart)="posIni = $event.changedTouches[0].pageX" (touchend)="moveSlider($event.changedTouches[0].pageX)">
  <ngb-carousel
    #ngbCarousel
    [interval]="0"
    [showNavigationArrows]="carouselContents?.length > 1"
    [showNavigationIndicators]="!!contentlet().showIndicator"
    [ngClass]="cssClasses(contentlet())"
  >
    @for (content of carouselContents; track content) {
    <ng-template ngbSlide>
      <custom-dot-cms-content-render [contentlet]="content" />
    </ng-template>
    }
  </ngb-carousel>
</div>
} }
